"use client";
import { useState, useEffect } from "react";
import ModalReportJob from "components/ModalReportJob";
import { postReportRequest } from "store/actions/reports/postReport";
import { initialState } from "store/reducers/config/fetchConfig";
import { postNotification } from "bossjob-remote/dist/clientStorage";
import { useSharedData } from "bossjob-remote/dist/hooks";

import styles from "./ReportJob.pc.module.scss";

export default function ReportJob({ sessionid, jobId, data }) {
  const [reportJobReasonList, setReportJobReasonList] = useState(null);
  const isPostingReport = useSharedData("POST_REPORT_FETCHING");
  const [isShowReportJob, setIsShowReportJob] = useState<boolean>(false);
  const postReportResponse = useSharedData("POST_REPORT_RESPONSE");
  const config = useSharedData("CONFIG") ?? initialState.response;

  const handlePostReportJob = (reportJobData) => {
    const postReportJobPayload = {
      reportJobData
    };
    postNotification("DISPATCH", postReportRequest(postReportJobPayload));
  };
  useEffect(() => {
    setReportJobReasonList(config?.report_job_reasons ?? initialState.response.report_job_reasons);
  }, [config]);
  return (
    <>
      <div className={styles.reportJob}>
        <div
          onClick={() => {
            if (!sessionid) {
              sessionStorage.setItem("redirectPage", window?.location?.pathname);
              postNotification("SHOW_LOGIN_MODAL");
              return;
            }
            setIsShowReportJob(true);
          }}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='15'
            height='14'
            viewBox='0 0 15 14'
            fill='none'
          >
            <path
              d='M2.83337 8.75002C2.83337 8.75002 3.41671 8.16669 5.16671 8.16669C6.91671 8.16669 8.08337 9.33335 9.83337 9.33335C11.5834 9.33335 12.1667 8.75002 12.1667 8.75002V2.33335C12.1667 2.33335 11.5834 2.91669 9.83337 2.91669C8.08337 2.91669 6.91671 1.75002 5.16671 1.75002C3.41671 1.75002 2.83337 2.33335 2.83337 2.33335M2.83337 12.8334L2.83337 1.16669'
              stroke='#7D7D7D'
              strokeWidth='1.05'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
          <span>{data.report}</span>
        </div>
      </div>
      {isShowReportJob && reportJobReasonList.length && (
        <ModalReportJob
          isShowReportJob={isShowReportJob}
          handleShowReportJob={setIsShowReportJob}
          reportJobReasonList={reportJobReasonList}
          selectedJobId={jobId}
          handlePostReportJob={handlePostReportJob}
          isPostingReport={isPostingReport}
          postReportResponse={postReportResponse}
        />
      )}
    </>
  );
}
